export const GET_ALL_NOTIFICATIONS_RECIPIENTS = "GET_ALL_NOTIFICATIONS_RECIPIENTS";
export const RESET_DATA = "RESET_DATA";
export const START_LOADING_NOTIFICATIONS_RECIPIENTS = "START_LOADING_NOTIFICATIONS_RECIPIENTS";
export const STOP_LOADING_NOTIFICATIONS_RECIPIENTS = "STOP_LOADING_NOTIFICATIONS_RECIPIENTS";
export const ERROR_LOADING_NOTIFICATIONS_RECIPIENTS = "ERROR_LOADING_NOTIFICATIONS_RECIPIENTS";